
import { BarcodeScanner } from "./BarcodeScanner";
import { PhotoCapture } from "./PhotoCapture";
import { ImageZoomModal } from "./ImageZoomModal";

interface ProductListModalsProps {
  showScanner: boolean;
  onScanResult: (barcode: string) => void;
  onCloseScanner: () => void;
  showPhotoCapture: boolean;
  onPhotoCapture: (photoUrl: string) => void;
  onClosePhotoCapture: () => void;
  zoomedImage: string | null;
  onCloseZoomedImage: () => void;
}

export const ProductListModals = ({
  showScanner,
  onScanResult,
  onCloseScanner,
  showPhotoCapture,
  onPhotoCapture,
  onClosePhotoCapture,
  zoomedImage,
  onCloseZoomedImage
}: ProductListModalsProps) => {
  return (
    <>
      {showScanner && (
        <BarcodeScanner
          onScanResult={onScanResult}
          onClose={onCloseScanner}
        />
      )}

      {showPhotoCapture && (
        <PhotoCapture
          onPhotoCapture={onPhotoCapture}
          onClose={onClosePhotoCapture}
        />
      )}

      {zoomedImage && (
        <ImageZoomModal
          imageUrl={zoomedImage}
          onClose={onCloseZoomedImage}
        />
      )}
    </>
  );
};
